// AddonsManagement.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddonsManagement = () => {
  const [addons, setAddons] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingAddon, setEditingAddon] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    category: 'extra'
  });

  const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com/api";

  // Fixed useEffect - no ESLint warning
  useEffect(() => {
    const fetchAddons = async () => {
      try {
        const stallID = localStorage.getItem("stallID");
        const res = await axios.get(`${url}/api/admin/addons?stallID=${stallID}`);
        if (res.data.success) {
          setAddons(res.data.addons);
        }
      } catch (err) {
        console.error("Error fetching addons:", err);
      }
    };

    fetchAddons();
  }, [url]); // Only url as dependency

  // Rest of your component remains the same...
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const stallID = localStorage.getItem("stallID");
      const addonData = {
        ...formData,
        stallID: stallID,
        price: parseFloat(formData.price)
      };

      if (editingAddon) {
       alert(addonData.price);
        const res = await axios.put(`${url}/api/admin/addons/${editingAddon.id}`, addonData);
        if (res.data.success) {
          setAddons(addons.map(addon =>
            addon._id === editingAddon._id ? res.data.addon : addon
          ));
        }
      } else {
        const res = await axios.post(`${url}/api/admin/addons`, addonData);
        if (res.data.success) {
          setAddons([...addons, res.data.addon]);
        }
      }

      setFormData({ name: '', price: '', category: 'extra' });
      setEditingAddon(null);
      setShowForm(false);
    } catch (err) {
      console.error("Error saving addon:", err);
    }
  };

  const handleEdit = (addon) => {
   // alert(JSON.stringify(addon, null, 2)); // null and 2 for pretty printing
    setEditingAddon(addon);
    setFormData({
      name: addon.name,
      price: addon.price.toString(),
      category: addon.category
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this addon?")) {
      try {
        const res = await axios.delete(`${url}/api/admin/addons/${id}`);
        if (res.data.success) {
          setAddons(addons.filter(addon => addon._id !== id));
        }
      } catch (err) {
        console.error("Error deleting addon:", err);
      }
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', price: '', category: 'extra' });
    setEditingAddon(null);
    setShowForm(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>🍕 Addons Management</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(true)}
        >
          + Add New Addon
        </button>
      </div>

      {/* Rest of your JSX remains the same */}
      {showForm && (
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">
              {editingAddon ? 'Edit Addon' : 'Create New Addon'}
            </h5>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label">Addon Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="e.g., Extra Egg, Cheese, Bacon"
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Price (RM)</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    placeholder="0.00"
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Category</label>
                  <select
                    className="form-select"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="extra">Extra</option>
                    <option value="sauce">Sauce</option>
                    <option value="topping">Topping</option>
                    <option value="side">Side Dish</option>
                    <option value="drink">Drink</option>
                  </select>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                  <button type="submit" className="btn btn-success me-2">
                    {editingAddon ? 'Update' : 'Create'}
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Available Addons</h5>
          {addons.length === 0 ? (
            <p className="text-muted">No addons created yet. Click "Add New Addon" to get started.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {addons.map((addon) => (
                    <tr key={addon._id}>
                      <td>{addon.name}</td>
                      <td>
                        <span className={`badge ${
                          addon.category === 'extra' ? 'bg-primary' :
                          addon.category === 'sauce' ? 'bg-success' :
                          addon.category === 'topping' ? 'bg-warning' :
                          addon.category === 'side' ? 'bg-info' : 'bg-secondary'
                        }`}>
                          {addon.category}
                        </span>
                      </td>
                      <td>
  RM{addon.price ? Number(addon.price).toFixed(2) : "0.00"}
</td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => handleEdit(addon)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(addon._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-body">
          <h5 className="card-title">💡 Example Usage</h5>
          <p>Common addon examples for food stalls:</p>
          <ul>
            <li><strong>Extra Egg</strong> - RM 5.00 (Extra)</li>
            <li><strong>Extra Cheese</strong> - RM 20.00 (Extra)</li>
            <li><strong>Chilli Sauce</strong> - RM 5.00 (Sauce)</li>
            <li><strong>French Fries</strong> - RM 40.00 (Side Dish)</li>
            <li><strong>Coca Cola</strong> - RM 30.00 (Drink)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AddonsManagement;
